import { defaultHttpClient } from '../../httpClient';
import type { SuggestKeywordResponse } from '../types';

// 검색어 자동완성
export const getSuggestKeywords = async (keyword: string) => {
  return defaultHttpClient
    .request<SuggestKeywordResponse>({
      method: 'GET',
      url: '/api/v2/search/suggesters/',
      params: {
        query: keyword,
      },
    })
    .then(result => result.data);
};
